export function normalizeFirstName(raw: string | null | undefined) {
  return (raw ?? "").trim().replace(/\s+/g, " ")
}

export function normalizeLastInitial(raw: string | null | undefined) {
  const match = (raw ?? "").trim().match(/[A-Za-z]/)
  return match?.[0]?.toUpperCase() ?? ""
}

export function buildPlayerDisplayName({
  firstName,
  lastInitial,
}: {
  firstName: string | null | undefined
  lastInitial: string | null | undefined
}) {
  const normalizedFirstName = normalizeFirstName(firstName)
  const normalizedLastInitial = normalizeLastInitial(lastInitial)
  if (!normalizedFirstName || !normalizedLastInitial) return undefined
  return `${normalizedFirstName} ${normalizedLastInitial}`
}
